'use strict'

angular
  .module('basalteApp')
  .constant('BAS_DISCOVERED_SERVICES', {
    EVT_DISCOVERED_SERVICES_UPDATED: 'evtDiscoveredServicesUpdated',
    REMOVE_DEBOUNCE_TIMEOUT: 500
  })
